import React, { useState, useRef } from 'react'
import { CoreButton, CoreTextField } from 'src/components/core'
import { useDispatch, useSelector } from 'react-redux'
import { messageBoxHideAction } from 'src/reducers/message-box/action'
import {
  editSectionOrderAction,
  courseGetAction,
} from 'src/reducers/course/action'
import { useHistory } from 'react-router-dom'
import { getCardAction } from 'src/reducers/card/action'
const SectionNaming = props => {
  const { sections, setSections, editValueRef } = props
  const dispatch = useDispatch()
  const history = useHistory()
  const inputRef = useRef(null)
  const [localValue, setLocalValue] = useState('')
  const totalCardCount = useSelector(state => state.course.totalCardCount)
  const course = useSelector(state => state.course.course)

  React.useEffect(() => {
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus()
      }
    }, 100)
  }, [])
  const handleAdd = () => {
    if (!localValue || localValue.trim() === '') return
    dispatch(getCardAction())
    let newSection = {
      name: editValueRef.current,
      id: null,
      cards: [
        {
          id: null,
          type: 1,
          title: '',
          orderOfCard: totalCardCount,
        },
      ],
    }
    dispatch(
      editSectionOrderAction(
        course.id,
        {
          sections: [...sections, newSection],
        },
        response => {
          let stateSections = [...sections]
          newSection.id = response.sections[0].id
          newSection.cards[0].id = response.sections[0].cards[0].id
          stateSections.push(newSection)
          dispatch(courseGetAction(course.id))
          dispatch(getCardAction(response.sections[0].cards[0].id))
          history.push(
            `/mini-course/${course.id}/page/${response.sections[0].cards[0].id}`,
          )
          setSections(stateSections)
        },
      ),
    )
    dispatch(messageBoxHideAction())
  }

  const handleKeyPress = e => {
    if (e.key === 'Enter' && localValue && localValue.trim() !== '') {
      handleAdd()
    }
  }
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
      }}
      onKeyPress={handleKeyPress}
    >
      <CoreTextField
        label="Section Title"
        value={localValue}
        onChange={e => {
          setLocalValue(e.target.value)
          editValueRef.current = e.target.value
        }}
        fullWidth
        inputRef={inputRef}
      />
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: 16,
        }}
      >
        <CoreButton
          onClick={() => {
            dispatch(messageBoxHideAction())
          }}
          color="secondary"
          variant="text"
        >
          Cancel
        </CoreButton>
        <CoreButton
          disabled={!localValue || localValue.trim() === ''}
          onClick={() => handleAdd()}
        >
          Add
        </CoreButton>
      </div>
    </div>
  )
}

export default SectionNaming
